import { render, staticRenderFns } from "./DisasterStatistic.vue?vue&type=template&id=5b965274&scoped=true"
import script from "./DisasterStatistic.vue?vue&type=script&lang=js"
export * from "./DisasterStatistic.vue?vue&type=script&lang=js"
import style0 from "./DisasterStatistic.vue?vue&type=style&index=0&id=5b965274&prod&scoped=true&lang=css"
import style1 from "./DisasterStatistic.vue?vue&type=style&index=1&id=5b965274&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b965274",
  null
  
)

export default component.exports